import { render, staticRenderFns } from "./Wireframe.vue?vue&type=template&id=00a8f4b4&scoped=true"
import script from "./Wireframe.vue?vue&type=script&lang=js"
export * from "./Wireframe.vue?vue&type=script&lang=js"
import style0 from "./Wireframe.vue?vue&type=style&index=0&id=00a8f4b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a8f4b4",
  null
  
)

export default component.exports